import { render, staticRenderFns } from "./BaseLayoutMain.vue?vue&type=template&id=721784c4&scoped=true"
import script from "./BaseLayoutMain.vue?vue&type=script&lang=js"
export * from "./BaseLayoutMain.vue?vue&type=script&lang=js"
import style0 from "./BaseLayoutMain.vue?vue&type=style&index=0&id=721784c4&prod&lang=scss&scoped=true"
import style1 from "./BaseLayoutMain.vue?vue&type=style&index=1&id=721784c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721784c4",
  null
  
)

export default component.exports